import { render, staticRenderFns } from "./FinalDetails.vue?vue&type=template&id=1545d76a&"
import script from "./FinalDetails.vue?vue&type=script&lang=ts&"
export * from "./FinalDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports